import { Pipe, PipeTransform } from '@angular/core';
import { SelectOption, WarningTypeOptions } from '@fleet-beat/core';
import { LogbookRecordWarning } from '@fleet-beat/api';

@Pipe({
  name: 'warningsLabel',
  pure: true,
})
export class WarningsLabelPipe implements PipeTransform {
  transform(warnings: LogbookRecordWarning[] | null | undefined, types: string | string[]): string | null {
    if (!warnings?.length) {
      return null;
    }
    const typesArray = Array.isArray(types) ? types : [types];

    const relevantWarnings = warnings.filter((warning: LogbookRecordWarning) => typesArray.includes(warning.type));
    if (!relevantWarnings.length) {
      return null;
    }

    const labels = relevantWarnings.map((warning: LogbookRecordWarning) => {
      const found = WarningTypeOptions.find((opt: SelectOption) => opt.value === warning.type);
      return found?.label ?? warning.type;
    });

    const uniqueLabels = Array.from(new Set(labels));

    return uniqueLabels.join(', ');
  }
}
